import { useInView } from 'react-intersection-observer';
import "./FadeInSection.css";

function FadeInSection({ children, delay = "0s" }) {
    const { ref, inView } = useInView({
        triggerOnce: true,
        threshold: 0.6,
    });

    return (
        <div 
            ref={ref}
            style={{ transitionDelay: delay }}
            className={`fade-in-section ${inView ? "show" : ""}`}
        >
            {children}
        </div>
    );
}

export default FadeInSection;